var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import useUniqueId from "../../Hooks/useUniqueId";
/**
 * Expands or collapses to show content.
 */
const Collapse = (_a) => {
    var { children, open, className, unMountChildren } = _a, otherProps = __rest(_a, ["children", "open", "className", "unMountChildren"]);
    const [id] = useUniqueId();
    const [isCollapsed, setIsCollapsed] = React.useState(!open);
    const ref = React.useRef(null);
    React.useLayoutEffect(() => {
        let timeout = null;
        if (ref.current) {
            const elm = $(ref.current);
            if (open) {
                // This is a little hacky, but give the component a little time to mount and load before we open, so things
                // aren't as janky.
                timeout = setTimeout(() => {
                    elm.collapse("show");
                }, 20);
            }
            else {
                elm.collapse("hide");
            }
        }
        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [open]);
    React.useEffect(() => {
        // Collapse listeners
        if (ref.current) {
            const elm = $(ref.current);
            elm.on("show.bs.collapse", () => setIsCollapsed(false));
            elm.on("hidden.bs.collapse", () => setIsCollapsed(true));
            return () => {
                elm.off("hidden.bs.collapse");
                elm.off("show.bs.collapse");
            };
        }
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return () => { };
    }, []);
    return (_jsx("div", Object.assign({ className: `${className || ""} collapse` }, otherProps, { id: id, ref: ref, children: unMountChildren ? (!isCollapsed || open) && children : children })));
};
export default Collapse;
